/* template */
<template><div id="ad-container" v-show="(isShowAd)" class="ad-container"><ad-item v-show="(config1)" :config="(config1)" index="0"/><div class="line"></div><ad-item v-show="(config2)" :config="(config2)" index="1"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m50dd8fe4"}'>
  .ad-container
    display flex
    flex-direction row
    border-radius 16px
    background #FFFFFF
    margin-top 8.5px
    align-items center
    .line
      width 1px
      height 49px
      background #F3F4F5
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m50dd8fe4"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex50dd8fe4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex50dd8fe4%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m50dd8fe4"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index50dd8fe4/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'ad-item':getComponent(require("./ad-item.mpx?isComponent&outputPath=components%2Fad-itema6acfd62%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
